import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, ConfigModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';

import { KnBrDraftSearchResultModule } from './kn-br-draft-search-result/kn-br-draft-search-result.module';
import { KnBrCartPageOptionsComponentModule } from './kn-br-cart-page-options/kn-br-cart-page-options.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrCartPageOptionsComponentModule,
    KnBrDraftSearchResultModule,
    RouterModule.forChild([
      {
        data: { pageLabel: '/carts', cxRoute: 'carts' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          carts: {
            paths: ['carts'],
          },
        },
      },
    } as RoutingConfig),
  ],
})
export class KnBrDraftOrderListModule {}
